/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import vuetify from './vuetify'
// import jQuery from 'jquery'
import Aos from 'aos'
import moment from 'moment'
import 'aos/dist/aos.css'
import * as convert from 'color-convert'
import Vue from 'vue'
import tinymce from 'tinymce'
import 'tinymce/themes/silver'
import 'tinymce/icons/default/icons'
import 'tinymce-i18n/langs/fr_FR'
import contentUiCss from 'tinymce/skins/ui/oxide/content.css'
import skinUiCss from 'tinymce/skins/ui/oxide/skin.css'
import contentCss from 'tinymce/skins/content/default/content.css'
import Cookies from 'js-cookie'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vSelect from 'vue-select'
import i18n from './i18n'
import { theme, setTheme } from './utils/theme'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import FlagIcon from 'vue-flag-icon'
Vue.mixin({
    computed: {
        theme() {
            return theme
        },
    },
})
import PostHog from './plugins/posthog'

Vue.use(PostHog)
Vue.use(FlagIcon)

Vue.use(VueAxios, axios)
Vue.use(Toast, {
    container: () => document.getElementById('toast-permanent-container') || document.body,
    transition: 'Vue-Toastification__bounce',
    maxToasts: 20,
    newestOnTop: true,
    position: 'top-right',
    timeout: 3000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: 'button',
    icon: true,
    rtl: false,
})

var momentRange = require('moment-range')
momentRange.extendMoment(moment)

import VModal from 'vue-js-modal/dist/index.nocss.js'
import 'vue-js-modal/dist/styles.css'
Vue.use(VModal, { dialog: true, dynamicDefault: { draggable: true, resizable: true } })

require('./bootstrap')
require('./modal')

// window.jQuery = jQuery
window.Aos = Aos
window.moment = moment
window.colorConvert = convert
window.tinymce = tinymce
window.contentUiCss = contentUiCss
window.skinUiCss = skinUiCss
window.contentCss = contentCss
window.Cookies = Cookies

window.Vue = require('vue').default
Vue.component('admin-sidebar', require('./components/AdminSidebar.vue').default)
// Vue.component("carousel-component", require("./components/App.vue").default);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
Vue.prototype.$symbolCurrency = window.symbolCurrency || '€'
Vue.prototype.$codeCurrency = window.codeCurrency || 'EUR'
Vue.prototype.$currencyLocale = window.currencyLocale || 'fr-FR'
Vue.prototype.$priceDecimal = window.priceDecimal
Vue.prototype.$priceHtDecimal = window.priceHtDecimal
Vue.prototype.$placeholderText = function (string1, $symbolCurrency, $string) {
    return ` ${string1 + $symbolCurrency + $string}`
}
Vue.component('color-picker', require('./components/ColorPicker.vue').default)
Vue.component('carousel-custom', require('./components/Carousel.vue').default)
Vue.component('time-slot', require('./components/TimeSlot.vue').default)
Vue.component('calendar-custom', require('./components/Calendar/Calendar.vue').default)
Vue.component('calendar-v3', require('./components/Calendar/CalendarV3.vue').default)
Vue.component('Product', require('./components/Calendar/Modal/Product.vue').default)
// Vue.component('calendar-custom2', require('./components/Calendar2/Calendar.vue').default)
Vue.component('list-prescriptions', require('./components/PrescriptionsList.vue').default)
// Vue.component('carousels-prescriptions', require('./components/CarouselsPrescription.vue').default)
Vue.component('prestation-select', require('./components/Prestation_BO/Prestation.vue').default)

Vue.component('info-establishment', require('./components/Basket/BasketEstablishment.vue').default)
Vue.component('survey-question', require('./components/Surveys/SurveyQuestion.vue').default)
Vue.component('survey-fo', require('./components/Surveys/SurveyFO.vue').default)
Vue.component('survey-form', require('./components/Surveys/SurveyForm.vue').default)
Vue.component('series-form', require('./components/Series/PrestationsForm.vue').default)
Vue.component('faq-component', require('./components/Surveys/FAQComponent.vue').default)
Vue.component('survey-description-component', require('./components/Surveys/SurveyDescriptionComponent.vue').default)

Vue.component('checkout-component', require('./components/Checkout_BO/Checkout.vue').default)
Vue.component('checkout-overlay', require('./components/Checkout_BO/CheckoutOverlay/Overlay.vue').default)
Vue.component('waiting-sales-tab', require('./components/Checkout_BO/CheckoutOverlay/WaitingSales.vue').default)
Vue.component('contributor-tab', require('./components/Checkout_BO/CheckoutOverlay/Contributor.vue').default)
Vue.component('serie-treatment-tab', require('./components/Checkout_BO/CheckoutOverlay/SerieTreatment.vue').default)
Vue.component('serie-tab', require('./components/Checkout_BO/CheckoutOverlay/Serie.vue').default)
Vue.component('serie-treatment-modal', require('./components/Checkout_BO/CheckoutOverlay/SerieTreatmentModal.vue').default)
Vue.component('voucher-tab', require('./components/Checkout_BO/CheckoutOverlay/Voucher.vue').default)
Vue.component('voucher-validation', require('./components/Checkout_BO/VoucherValidation.vue').default)
Vue.component('cart-component', require('./components/Checkout_BO/CheckoutOverlay/Cart.vue').default)
Vue.component('payment-component', require('./components/Checkout_BO/CheckoutOverlay/Payment.vue').default)
Vue.component('close-sale-modal', require('./components/Checkout_BO/CheckoutOverlay/CloseSaleModal.vue').default)
Vue.component('staff-modal', require('./components/Checkout_BO/CheckoutOverlay/StaffModal.vue').default)
Vue.component('Staff', require('./components/Staff.vue').default)
Vue.component('calenders', require('./components/CalenderS.vue').default)
Vue.component('planning-calender', require('./components/Prestation/PlanningCalender.vue').default)
Vue.component('prestation-reservation-periods', require('./components/Prestation/PrestationReservation.vue').default)

Vue.component('PrestationReservationPeriod', require('./components/Prestation/PrestationReservationPeriod.vue').default)
Vue.component('order-actions-menu', require('./components/Orders/OrderActionsMenu.vue').default)

Vue.component('contributor-list', require('./components/Calendar/Modal/parts/ContributorList.vue').default)
Vue.component('NewClient', require('./components/Calendar/Modal/parts/NewClient.vue').default)

Vue.component('treatment-timeline', require('./components/Treatment/TreatmentTimeline').default)
Vue.component('payment-method-component', require('./components/Order/PaymentMethod.vue').default)
Vue.component('payment-method-amount-component', require('./components/Order/PaymentMethodAmount.vue').default)

/** Food management */
Vue.component('food-categories-component', require('./components/Food/Categories/AddUpdateFoodCategory.vue').default)
Vue.component('food-menus-add-update', require('./components/Food/Menus/AddUpdateFoodMenu.vue').default)
Vue.component('food-packs-add-update', require('./components/Food/Packs/AddUpdateFoodPack.vue').default)
Vue.component('food-tables-add-update', require('./components/Food/Tables/AddUpdateFoodTable.vue').default)
Vue.component('food-tables-index', require('./components/Food/Tables/Index.vue').default)
Vue.component('food-tables-draggable', require('./components/Food/Tables/DraggableIFoodTables.vue').default)
Vue.component('food-add-update', require('./components/Food/AddUpdateFood.vue').default)
Vue.component('food-draggable-items', require('./components/Food/DraggableIFoodtems.vue').default)
Vue.component('food-categories-draggable-items', require('./components/Food/Categories/DraggableFoodCategoriesItems.vue').default)

/* gestion template devis */
Vue.component('gestion-template-devis', require('./components/Gestion_template/Devis.vue').default)
/* template-model-devis */

/** customer v2 management */
Vue.component('bo-customer-index', require('./components/Customer/v2/BoCustomerIndex.vue').default)
Vue.component('bo-customer-edit', require('./components/Customer/BoCustomerEdit.vue').default)
Vue.component('voucher-datatable-v2', require('./components/Customer/v2/VoucherDatatableV2.vue').default)
Vue.component('billet-datatable-v2', require('./components/Customer/v2/BilletDatatableV2.vue').default)

/** Marketing emails management */
Vue.component('bo-marketing-emails-index', require('./components/Marketing/CampaingEmailIndex.vue').default)
Vue.component('bo-marketing-emails', require('./components/Marketing/CompaingEmails.vue').default)
Vue.component('bo-marketing-emails-create', require('./components/Marketing/CompaingEmailsCreate.vue').default)
Vue.component('bo-marketing-emails-models', require('./components/Marketing/CompaingEmailsModels.vue').default)
Vue.component('bo-marketing-emails-models-editor', require('./components/Marketing/CompaingEmailsModelEditor.vue').default)
Vue.component('bo-marketing-emails-statistic', require('./components/Marketing/CampaingEmailList.vue').default)
Vue.component('bo-marketing-emails-calender', require('./components/Marketing/CampaingEmailCalender.vue').default)

Vue.component('activity-draggable-items', require('./components/Prestation/DraggablelActivitytems.vue').default)
Vue.component('package-add-update', require('./components/Package/AddUpdatePackage.vue').default)
Vue.component('tag-add-update', require('./components/Tag/AddUpdateTag.vue').default)
Vue.component('setting-mobile-intro', require('./components/Settings/SettingMobileIntro.vue').default)
Vue.component('package-categories-add-update', require('./components/Package/AddUpdatePackageCategory.vue').default)

// Tenant Registration Component
Vue.component('tenant-registration-new', require('./components/TenantRegistration/TenantRegistrationNew.vue').default)

Vue.component('vue-select', vSelect)
Vue.component('Devis', require('./components/Checkout_BO/CheckoutOverlay/Devis.vue').default)

Vue.component('etablissement-index', require('./components/V2/Etablissement/Index.vue').default)
Vue.component('etablissement-edit', require('./components/V2/Etablissement/EditIndex.vue').default)
Vue.component('widget-integration', require('./components/WidgetIntegration.vue').default)
Vue.component('widget-integration-v3', require('./components/V3/Widgets/WidgetIntegration.vue').default)
/* model template */
Vue.component('model-template-add-upate', require('./components/V2/ModelTemplate/AddUpdate.vue').default)
Vue.component('model-template-list', require('./components/V2/ModelTemplate/list.vue').default)

/* Help Desk */
Vue.component('helpdesk-form', require('./components/HelpdeskForm.vue').default)
Vue.component('helpdesk-index', require('./components/HelpdeskIndex.vue').default)

/* BO section communication -> push notification  */
Vue.component('bo-notification-push-form', require('./components/V2/NotificationPush/form.vue').default)
Vue.component('bo-notification-push-index', require('./components/V2/NotificationPush/index.vue').default)

/* BO section communication V3 -> push notification */
Vue.component('bo-notification-push-v3-index', require('./components/V3/Communication/NotificationPush/index.vue').default)
Vue.component('bo-notification-push-v3-form', require('./components/V3/Communication/NotificationPush/form.vue').default)

Vue.component('bo-sidebar-v3', require('./components/V3/SideBar.vue').default)
Vue.component('bo-header-v3', require('./components/V3/Header.vue').default)
Vue.component('bo-experience-v3-index', require('./components/V3/Experience/index.vue').default)
Vue.component('bo-experience-v3-create', require('./components/V3/Experience/create.vue').default)
Vue.component('bo-experience-v3-tag-form', require('./components/V3/Tag/TagFormPage.vue').default)
Vue.component('bo-experience-v3-create-simple', require('./components/V3/Experience/create-simple.vue').default)
Vue.component('bo-statistics-v3', require('./components/V3/Statistics/index.vue').default)
Vue.component('bo-dashboard-v3', require('./components/V3/Dashboard/index.vue').default)
Vue.component('bo-equipements-v3-index', require('./components/V3/Equipements/index.vue').default)
Vue.component('bo-equipements-v3-edit', require('./components/V3/Equipements/Edit.vue').default)
Vue.component('bo-package-v3-create', require('./components/V3/Package/create.vue').default)
Vue.component('bo-treatment-v3-create', require('./components/V3/Treatment/create.vue').default)
Vue.component('bo-serie-v3-create', require('./components/V3/Serie/create.vue').default)
Vue.component('bo-food-v3-index', require('./components/V3/Food/index.vue').default)
Vue.component('bo-food-v3-product-form', require('./components/V3/Food/ProductForm.vue').default)
Vue.component('bo-food-v3-pack-form', require('./components/V3/Food/PackForm.vue').default)
Vue.component('bo-product-v3-index', require('./components/V3/Product/index.vue').default)
Vue.component('bo-product-v3-form', require('./components/V3/Product/ProductForm.vue').default)
Vue.component('bo-caisse-v3-index', require('./components/V3/Caisse/index.vue').default)
Vue.component('product-stats-cards', require('./components/V3/Product/ProductStatsCards.vue').default)
Vue.component('bo-product-category-v3-index', require('./components/V3/Product/Categorie/index.vue').default)
Vue.component('bo-product-brand-v3-index', require('./components/V3/Product/Brand/index.vue').default)
Vue.component('bo-product-supplier-v3-index', require('./components/V3/Product/Supplier/index.vue').default)
Vue.component('bo-customer-v3-index', require('./components/V3/Customer/index.vue').default)
Vue.component('bo-customer-v3-view', require('./components/V3/Customer/CustomerInfo.vue').default)
Vue.component('bo-customer-v3-form', require('./components/V3/Customer/CustomerForm.vue').default)
Vue.component('bo-pos-v3-form', require('./components/V3/POS/POSForm.vue').default)
Vue.component('bo-pos-v3-index', require('./components/V3/POS/index.vue').default)
Vue.component('applications-table', require('./components/V3/Administration/ApplicationsTable.vue').default)
Vue.component('bo-group-customer-v3-index', require('./components/V3/Customer/Group/index.vue').default)
Vue.component('bo-voucher-customer-v3-index', require('./components/V3/Customer/Voucher/index.vue').default)
Vue.component('bo-send-voucher-v3-form', require('./components/V3/Customer/Voucher/SendVoucherForm.vue').default)
Vue.component('bo-billet-non-date-customer-v3-index', require('./components/V3/Customer/BilletNonDate/index.vue').default)
Vue.component('bo-treatment-customer-v3-index', require('./components/V3/Customer/Treatment/index.vue').default)
Vue.component('bo-export-v3-index', require('./components/V3/Export/index.vue').default)
Vue.component('bo-annonce-v3-index', require('./components/V3/Marketing/Annonce/index.vue').default)
Vue.component('bo-blog-v3-index', require('./components/V3/Marketing/Blog/index.vue').default)
Vue.component('bo-blog-v3-create', require('./components/V3/Marketing/Blog/create.vue').default)
Vue.component('bo-form-question-v3-index', require('./components/V3/FormQuestion/index.vue').default)
Vue.component('bo-resource-v3-index', require('./components/V3/Resource/index.vue').default)
Vue.component('bo-integration-v3-index', require('./components/V3/Integration/index.vue').default)
Vue.component('bo-marketing-promotion-index', require('./components/V3/Marketing/Promotion/index.vue').default)
Vue.component('bo-marketing-promotion-form', require('./components/V3/Marketing/Promotion/PromotionForm.vue').default)
Vue.component('bo-marketing-promotion-table', require('./components/V3/Marketing/Promotion/PromotionTable.vue').default)
Vue.component(
    'bo-marketing-abandoned-cart-recovery',
    require('./components/V3/Marketing/AbandonedCart/AbandonedCartRecovery.vue').default
)
Vue.component('bo-profil-v3-form', require('./components/V3/Profile/ProfilForm.vue').default)
Vue.component('bo-staffs-v3-index', require('./components/V3/Staff/index.vue').default)
Vue.component('bo-staffs-v3-form', require('./components/V3/Staff/StaffForm.vue').default)
Vue.component('planning-staffs-v3', require('./components/V3/Staff/PlanningStaffsV3.vue').default)
Vue.component('roles-v3-index', require('./components/V3/Roles/index.vue').default)
Vue.component('roles-v3-form', require('./components/V3/Roles/RoleForm.vue').default)
Vue.component('roles-v3-list', require('./components/V3/Roles/RoleList.vue').default)
Vue.component('bo-website-settings-v3-index', require('./components/V3/Website/Settings/index.vue').default)
Vue.component('bo-mail-custom-v3-index', require('./components/V3/Establishment/MailCustom/index.vue').default)

import NavBar from './components/V3/Navbar/NavBar.vue'
import HeaderMobile from './components/V3/HeaderMobile.vue'

// Function to mount the Navbar (Persistent)
function mountNavbar() {
    const el = document.getElementById('search_bloc')
    if (el && !window.navbarApp) {
        const user = el.dataset.user ? JSON.parse(el.dataset.user) : null
        const roles = el.dataset.roles ? JSON.parse(el.dataset.roles) : null
        const hasPublishedExperiences = el.dataset.hasPublishedExperiences === 'true'
        const establishmentSettingsStatus = el.dataset.establishmentSettingsStatus
            ? JSON.parse(el.dataset.establishmentSettingsStatus)
            : null
        const establishmentId = el.dataset.establishmentId
        const isSubscribed = el.dataset.isSubscribed === 'true'
        const trialEndsIn = parseInt(el.dataset.trialEndsIn || '-1')
        const planName = el.dataset.planName || ''
        const currentRoute = window.location.pathname.split('/').pop() || '' // basic fallback

        // Mount Desktop Navbar
        window.navbarApp = new Vue({
            i18n,
            vuetify,
            store,
            render: (h) =>
                h(NavBar, {
                    props: {
                        user,
                        isSubscribed,
                        roles,
                        hasPublishedExperiences,
                        establishmentSettingsStatus,
                        establishmentId,
                        trialEndsIn,
                        planName,
                    },
                }),
        }).$mount('#search_bloc')

        const elMobile = document.getElementById('search_bloc_mobile')
        if (elMobile && !window.headerMobileApp) {
            window.headerMobileApp = new Vue({
                i18n,
                vuetify,
                store,
                data() {
                    return {
                        localCurrentRoute: elMobile.dataset.currentRoute || currentRoute,
                    }
                },
                render(h) {
                    return h(HeaderMobile, {
                        props: {
                            currentRoute: this.localCurrentRoute,
                            user,
                            isSubscribed,
                            roles,
                            hasPublishedExperiences,
                            establishmentSettingsStatus,
                            establishmentId,
                            trialEndsIn,
                            planName,
                        },
                    })
                },
            }).$mount('#search_bloc_mobile')
        } else if (elMobile && window.headerMobileApp) {
            const routeNameMeta = document.querySelector('meta[name="current-route-name"]')
            if (routeNameMeta) {
                window.headerMobileApp.localCurrentRoute = routeNameMeta.content
            }
        }
    }
}

Vue.component('multi-select-with-remove', require('./components/MultiSelectWithRemove.vue').default)

/* Shared Components */
Vue.component('shared-header', require('./components/Shared/Header.vue').default)
Vue.component('data-table', require('./components/Shared/DataTable.vue').default)
Vue.component('confirmation-dialog', require('./components/Shared/ConfirmationDialog.vue').default)
Vue.component('base-textarea', require('./components/Shared/BaseTextarea.vue').default)

/* Invoices V2 */
Vue.component('invoices-page-v2', require('./components/Invoices/InvoicesPageV2.vue').default)
Vue.component('invoice-stats-cards', require('./components/Invoices/InvoiceStatsCards.vue').default)
Vue.component('invoice-date-filter', require('./components/Invoices/InvoiceDateFilter.vue').default)
Vue.component('invoice-data-table', require('./components/Invoices/InvoiceDataTable.vue').default)
Vue.component('invoice-columns-selector', require('./components/Invoices/InvoiceColumnsSelector.vue').default)
Vue.component('invoice-advanced-filters', require('./components/Invoices/InvoiceAdvancedFilters.vue').default)

/* Invoices V3 */
Vue.component('invoices-page-v3', require('./components/Invoices/InvoicesPageV3.vue').default)
Vue.component('invoices-en-attente-page', require('./components/Invoices/InvoicesEnAttentePage.vue').default)
Vue.component('validated-invoices-data-table', require('./components/Invoices/ValidatedInvoicesDataTable.vue').default)
Vue.component('draft-orders-data-table', require('./components/Invoices/DraftOrdersDataTable.vue').default)
Vue.component('devis-page', require('./components/Devis/DevisPage.vue').default)
Vue.component('create-devis-page-v3', require('./components/Devis/V3/Create.vue').default)
Vue.component('devis-data-table', require('./components/Devis/DevisDataTable.vue').default)
Vue.component('subscription-page', require('./components/Subscription/Index.vue').default)
Vue.component('manage-subscription', require('./components/Subscription/Manage.vue').default)

Vue.component('available-soon', require('./components/Static/AvailableSoon.vue').default)
Vue.component('bo-enhancement-banner', require('./components/Shared/EnhancementBanner.vue').default)
Vue.component('bo-version-switch-banner', require('./components/Shared/VersionSwitchBanner.vue').default)

/* Log Viewer */
Vue.component('log-viewer', require('./components/LogViewer.vue').default)

import VueNotify from 'vuejs-notify'
Vue.use(VueNotify)

//Vue.component('serie-timeline', require('./components/Serie/SerieTimeline').default)
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Initialize Turbo
import * as Turbo from '@hotwired/turbo'
Turbo.start()

// Disable Turbo caching to prevent stale page issues
document.addEventListener('turbo:before-cache', () => {
    // Destroy the main content Vue instance before caching
    if (window.mainApp) {
        window.mainApp.$destroy()
        window.mainApp = null
    }
})

import Pathify from 'vuex-pathify'
setTheme(theme.mode)

Pathify.options.deep = 2

// Function to mount the Sidebar (Persistent)
function mountSidebar() {
    const sidebarElement = document.getElementById('sidebar_app')
    if (sidebarElement && !window.sidebarApp) {
        window.sidebarApp = new Vue({
            i18n,
            store,
            vuetify,
            el: '#sidebar_app',
            // We can add a data property to track the current route
            data: {
                currentRouteName: sidebarElement.querySelector('bo-sidebar-v3')?.getAttribute('initial-route') || '',
            },
            created() {
                // Listen for Turbo navigation to update the route
                document.addEventListener('turbo:load', () => {
                    const routeNameMeta = document.querySelector('meta[name="current-route-name"]')
                    if (routeNameMeta) {
                        this.currentRouteName = routeNameMeta.content
                        if (this.$children[0]) {
                            this.$children[0].currentRoute = routeNameMeta.content
                        }
                    }
                })
            },
        })
    } else if (sidebarElement && window.sidebarApp) {
        // Sidebar already exists, just update the route on subsequent navigations
        const routeNameMeta = document.querySelector('meta[name="current-route-name"]')
        if (routeNameMeta && window.sidebarApp.$children[0]) {
            window.sidebarApp.$children[0].currentRoute = routeNameMeta.content
        }
    }
}

// Function to mount the Main Content (Transient)
function mountMainContent() {
    const mainElement = document.getElementById('main-container')
    // Also handle #app for tenant registration which might be full page
    const appElement = document.getElementById('app')

    const targetElement = appElement || mainElement

    if (targetElement) {
        // Destroy previous instance if it exists
        if (window.mainApp) {
            window.mainApp.$destroy()
        }

        window.mainApp = new Vue({
            i18n,
            store,
            vuetify,
            el: targetElement,
            methods: {
                onClientAdded(client) {
                    // Close the modal
                    const modalElement = document.getElementById('modal-new-customer')
                    if (modalElement) {
                        const modal = bootstrap.Modal.getInstance(modalElement) || new bootstrap.Modal(modalElement)
                        modal.hide()
                    }
                },
            },
        })
    }
}

// Function to mount the Global Banners
function mountGlobalBanners() {
    const bannersEl = document.getElementById('global-banners-mount')
    if (bannersEl) {
        // Destroy previous instance if it exists
        if (window.bannersApp) {
            window.bannersApp.$destroy()
        }

        window.bannersApp = new Vue({
            i18n,
            render: (h) =>
                h(require('./components/Shared/BannersContainer.vue').default, {
                    props: {
                        paymentFailure: bannersEl.dataset.paymentFailure === 'true',
                        trialEndsIn: parseInt(bannersEl.dataset.trialEndsIn || '0'),
                        subscriptionCanceled: bannersEl.dataset.subscriptionCanceled === 'true',
                        subscriptionEndsAt: bannersEl.dataset.subscriptionEndsAt || '',
                    },
                }),
        }).$mount('#global-banners-mount')
    }
}

// Initialize on Turbo Load
document.addEventListener('turbo:load', () => {
    // 1. Mount Sidebar (if not already mounted)
    mountSidebar()

    // 2. Mount Navbar (if not already mounted)
    mountNavbar()

    // 3. Mount Main Content (always new)
    mountMainContent()

    // 4. Mount Global Banners
    mountGlobalBanners()

    // 4. Re-apply theme references
    setTheme(theme.mode)

    // 5. Re-initialize other global scripts if needed (AOS, etc.)
    if (window.Aos) {
        window.Aos.refresh()
    }
})

// Initial load (for the very first page visit)
// document.addEventListener("DOMContentLoaded", ...) is handled by turbo:load which fires on initial load too.
